<template>
    <div class="mt-1 relative rounded-md shadow-sm">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span class="text-gray-500 sm:text-sm"> € </span>
        </div>
        <input
            type="number"
            step="0.01"
            :name="numberNameInput"
            :id="numberNameInput"
            v-model="number"
            class="disable-input-arrows focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
        />
        <div class="absolute inset-y-0 right-0 flex items-center">
            <!--            <label for="coun    try" class="sr-only">Country</label>-->
            <select
                :id="selectNameInput"
                :name="selectNameInput"
                v-model="select"
                class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
            >
                <option value="">{{ $t('messages.no_info') }}</option>
                <option value="true">{{ $t('messages.yes') }}</option>
                <option value="false">{{ $t('messages.No') }}</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            select: '',
            number: null,
        };
    },
    props: {
        selectNameInput: {
            type: String,
            required: true,
        },
        numberNameInput: {
            type: String,
            required: true,
        },
        selectInput: {
            type: Boolean,
            required: true,
        },
        numberInput: {
            type: Number,
            required: true,
        },
    },
    mounted() {
        this.select = this.selectInput === null ? '' : this.selectInput;
        this.number = this.numberInput;
    },
    watch: {
        number: function number(newNumber) {
            if (newNumber > 0) {
                this.select = true;
            }
        },
    },
};
</script>
